import { CSSProperties, ReactNode } from "react";

type Props = {
  maxWidth?: number;
  children: ReactNode;
  contentStyle?: CSSProperties;
};

export function Modal({ maxWidth = 440, children, contentStyle }: Props) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        zIndex: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          background: "var(--bg-card)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          padding: 28,
          maxWidth,
          width: "100%",
          boxShadow: "var(--sh-3)",
          ...contentStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
}
